import { SubFsmBuilder } from "little-fsm";
import { TentativeBookingReviewFsmContext } from "./TentativeBookingReviewFsmContext";
import { TentativeBookingDTO, TravellerDTO } from "../../apiclient/ApiDtos";

export type TentativeBookingReviewFsmScheme = {
    context: TentativeBookingReviewFsmContext,
    substates: [
        'showing_review',
        'showing_update_form',
        'updating',
        'showing_update_error',
        'back_navigation_confirming'
    ],
    events: {
        'back': {},
        'back_confirmed': {},
        'back_cancelled': {},
        "update_initiated": {},
        "update_submitted": { travellerInfo: TravellerDTO },
        "update_failed": {},
        "update_succeeded": { tentativeBooking: TentativeBookingDTO },
        "review_completed": {}
    }
}

// just simple identity function
const $I = (x) => x;

export function tentativeBookingReviewSubFsmBuilder(): SubFsmBuilder<TentativeBookingReviewFsmScheme> {
    let subBuilder = new SubFsmBuilder<TentativeBookingReviewFsmScheme>();

    subBuilder.entrySubstate("showing_review")

    subBuilder.substate("showing_review")
        .transition("update_initiated", 'showing_update_form', (c, e) => c)
        .transition("back", "back_navigation_confirming", (c, e) => c)
        .completion("review_completed", (c, e) => c)

    subBuilder.substate("back_navigation_confirming")
        .transition("back", "showing_review", $I)
        .transition('back_cancelled', 'showing_review', $I)
        .termination('back_confirmed', $I)

    subBuilder.substate("showing_update_form")
        .transition('update_submitted', 'updating', (c, e) => {
            return c.withTravellerInfo(e.travellerInfo);
        })
        .transition('back', 'showing_review', $I)

    subBuilder.substate("updating")
        .transition('update_failed', 'showing_update_error', $I)
        .transition('update_succeeded', 'showing_review', (c, e) => c.withTentativeBooking(e.tentativeBooking))

    subBuilder.substate("showing_update_error")
        .transition("back", 'showing_review', $I)

    return subBuilder;
}


